const setLocalnavPulldown = () => {
  const targets = document.querySelectorAll('.js-localnav-pulldown');
  if (!targets.length) return false;

  targets.forEach(target => {
    target.addEventListener('click', () => {
      target.classList.toggle('is-open');
    })
  })
};

export default setLocalnavPulldown;